import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import { PharmaciesFiltersContext } from '../../../../context/PharmaciesFiltersContext'
import ChartColumn from '../../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber, formatCurrency } from '../../../../utils/Helpers'
import { STATUS_DELIVERED } from '../../../../types/Order'

const GET_GREATER_SHIPING = gql`
  query GreaterShipping($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: {
                  value: "${STATUS_DELIVERED}"
                }
              }
            },
            {
              range: {
                total: {
                  gt: 0
                }
              }
            }
          ]
        }
      },
      aggs: {
        pharmacies: {
          terms: {
            field: "pharmacy_name.keyword",
            size: 10,
            order: {
              shippingPrices: "desc"
            }
          },
          aggs: {
            shippingPrices: {
              max: {
                field: "shipping.cost"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number,
  shippingPrices: {
    value: number
  }
}
const GreaterShipping = (): JSX.Element => {
  const { filters } = useContext(PharmaciesFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_GREATER_SHIPING, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.pharmacies
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.shippingPrices.value)
  })

  const options = {
    chart: {
      id: 'higher-shipping'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetY: -20,
      formatter: (val: number) => {
        return formatNumber(val, 2, true)
      },
      style: {
        colors: ['#304758']
      }
    },
    yaxis: {
      labels: {
        formatter: (value: number) => {
          return formatCurrency(value, 2)
        }
      }
    }
  }
  const series = [{
    name: 'Frete',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      TOP 10 farmácias com maior frete
    </Typography>
    <ChartColumn options={options} series={series} theme={ChartColumnThemes.red} height={280} />
  </Paper>
}

export default GreaterShipping
